function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_59",
  "data-name": "Ellipse 59",
  cx: 3,
  cy: 3,
  r: 3,
  transform: "translate(10.7 21.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_60",
  "data-name": "Ellipse 60",
  cx: 3,
  cy: 3,
  r: 3,
  transform: "translate(34.9 21.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1656",
  "data-name": "Rectangle 1656",
  width: 25,
  height: 19,
  transform: "translate(8 0.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1176",
  "data-name": "Path 1176",
  d: "M41.3,24.5H44V14.9L37.7,6.8H35.9",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  id: "Line_104",
  "data-name": "Line 104",
  x1: 18.9,
  transform: "translate(16.1 24.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  id: "Line_105",
  "data-name": "Line 105",
  x1: 3.7,
  transform: "translate(7 24.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  id: "Line_106",
  "data-name": "Line 106",
  x1: 5,
  transform: "translate(0 16.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  id: "Line_107",
  "data-name": "Line 107",
  x1: 3,
  transform: "translate(2 19.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var SvgIconTruck = function SvgIconTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_77",
    "data-name": "Group 77",
    width: 44.5,
    height: 28,
    viewBox: "0 0 44.5 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_truck.e14bc946.svg";
export { ForwardRef as ReactComponent };